import { ClipboardList } from "lucide-react";
import { Badge } from "@/components/agent/AgentUI";

// Mismo orden que la plantilla de la guía del CCE (backend/agent/claude_agent.py).
export const FICHA_FIELDS = [
  ["titulo", "Título"], ["reto", "Reto"], ["problema", "Problema"], ["propuesta", "Propuesta"], ["clasificacion", "Clasificación"],
  ["marco_normativo", "Marco normativo"], ["responsables", "Responsables y aliados"], ["riesgo", "Riesgo y ajuste clave"],
  ["indicador", "Indicador"], ["siguiente_paso", "Siguiente paso (90 días)"], ["evidencia", "Evidencia"], ["pendientes", "Pendientes por verificar"],
  ["nombre", "Nombre"], ["empresa", "Empresa"], ["correo", "Correo"],
];

export const FichaPanel = ({ ficha, folios, title = "Ficha en curso" }) => {
  const rows = FICHA_FIELDS.filter(([key]) => ficha?.[key]);
  return <div className="ag-ficha" data-testid="agent-ficha-panel">
    <div className="ag-ficha-heading"><ClipboardList size={16} /><b>{title}</b>{!!folios?.length && <Badge tone="green" id="agent-ficha-folios">{folios.length === 1 ? "1 registrada" : `${folios.length} registradas`}</Badge>}</div>
    {!rows.length ? <p className="ag-muted" data-testid="agent-ficha-empty">El agente llena la ficha conforme avanza la conversación.</p> :
      <dl>{rows.map(([key, label]) => <div key={key}><dt>{label}</dt><dd data-testid={`agent-ficha-${key}`}>{ficha[key]}</dd></div>)}</dl>}
    {!!folios?.length && <p className="ag-muted" data-testid="agent-ficha-folio-list">Folios: {folios.join(", ")}</p>}
  </div>;
};
